<template>
  <div class="outer" v-if="isActive" :class="bgColor">
    <div class="inner">
      <p>{{message}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isActive', 'bgColor', 'message']
}
</script>

<style lang="scss" scoped>
  @import './../css/variables.css';

  .outer {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    display: flex;
    background: rgba(255, 255, 255, 0.7);

    .inner {
      background: var(--azure);
    }

    &.aqua {
      .inner {
        background: var(--aqua);
      }
    }

    &.light-purple {
      .inner {
        background: var(--light_purple);
      }
    }
  }

  .inner {
    margin: auto;
  }

  p {
    padding: 20px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/vue/components/NoInteractionOverlay.vue